import { useSelector } from "react-redux";
import ReusableDatagrid from "../components/ReusableDatagrid";

const columnsConfig = [
  {
    field: "wsgrHandles",
    headerName: "WSGR Responsible?",
    width: 180,
    type: "select",
    label: "Select Yes/No",
    options: [
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },
    ],
    autoPopulate: {
      when: (value) => value === "Yes",
      fields: { prosecutingFirm: "WSGR" },
    },
  },
  {
    field: "familyNo",
    headerName: "Family No(s)",
    width: 240,
    placeholder: "Enter Family No(s)",
  },
  {
    field: "prosecutingFirm",
    headerName: "Prosecuting Firm Name",
    width: 340,
    placeholder: "Enter Firm Name",
  },
  {
    field: "notes",
    headerName: "Notes",
    width: 360,
    placeholder: "Enter Notes",
  },
];

export default function StatusByFamily({ mode }) {
  const savedData = useSelector((state) => state.kotClient.statusByFamily);
  return <ReusableDatagrid title="Status by Family" columnsConfig={columnsConfig} initialRows={savedData} section={"statusByFamily"} mode={mode} />;
}
